module.exports = __webpack_public_path__ + "media/app/assets/imgs/landing_2025/collection-5b0b4e21136146fb29ac9a328d09b817.png";